import { render, staticRenderFns } from "./AstaPoker.vue?vue&type=template&id=c7082594&"
import script from "./AstaPoker.vue?vue&type=script&lang=js&"
export * from "./AstaPoker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7082594')) {
      api.createRecord('c7082594', component.options)
    } else {
      api.reload('c7082594', component.options)
    }
    module.hot.accept("./AstaPoker.vue?vue&type=template&id=c7082594&", function () {
      api.rerender('c7082594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaPoker.vue"
export default component.exports